import { render, staticRenderFns } from "./onlineTraining.vue?vue&type=template&id=43f51bd6&scoped=true"
import script from "./onlineTraining.vue?vue&type=script&lang=js"
export * from "./onlineTraining.vue?vue&type=script&lang=js"
import style0 from "./onlineTraining.vue?vue&type=style&index=0&id=43f51bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f51bd6",
  null
  
)

export default component.exports